<!-- @Author: xiaoyaqu -->
<!-- @Date: 2019-06-05 19:59:11.774 -->
<!-- @Last Modified by: ruiwang -->
<!-- @Last Modified time: 2023-10-12 15:29:09 -->

<template>
    <div class="ec-footer">
        <div class="contact-info padding-top ec-container">
            <div class="top-wrapper">
                <div class="customer-left">
                    <div class="customer-item">
                        <img
                            src="./img/icons/easycash.svg"
                            alt="easycashlogo"
                            class="customer-item-logo"
                        >
                        <div class="contact-ec">
                            {{ $t('footer.contact') }}
                        </div>
                    </div>
                    <div
                        v-for="(item, index) in customerList"
                        :key="index"
                        class="customer-item customer-item-contact"
                    >
                        <div
                            class="customer-item-top"
                            :style="{'border-left': `2px solid ${item.color}`}"
                        >
                            <div class="title">
                                {{ item.title }}
                            </div>
                            <div class="contact">
                                <div
                                    v-for="(it, ix) in item.contact"
                                    :key="ix"
                                    class="contact-item"
                                    :style="{
                                        'min-width': it.minWidth
                                    }"
                                >
                                    <img
                                        :src="it.icon"
                                        class="customer-item-icon"
                                    >
                                    <a
                                        v-if="ix === 0"
                                        :href="`tel:${it.value}`"
                                    >{{ it.value }}</a>
                                    <a
                                        v-else-if="ix === 1"
                                        :href="`mailto:${it.value}`"
                                    >{{ it.value }}</a>
                                    <span v-else>{{ it.value }}</span>
                                </div>
                            </div>
                            <div
                                v-if="customerServiceTimeTip"
                                class="special-time"
                            >
                                {{ customerServiceTimeTip }}
                            </div>
                            <div
                                v-if="showWhatsapp"
                                class="contact whatsapp"
                            >
                                <div
                                    class="contact-item"
                                    :style="{
                                        width: '100%',
                                        marginTop: '0'
                                    }"
                                >
                                    <div
                                        v-if="(isHoverBorrow && index === 0) || (isHoverLend && index === 1)"
                                        class="qr-wrap"
                                    >
                                        <img
                                            class="qr-code"
                                            :src="whatsappQr"
                                            alt=""
                                        >
                                    </div>
                                    <div class="whatsapp">
                                        <img
                                            src="./img/icons/whatsapp.svg"
                                            class="customer-item-icon"
                                        >
                                        <a
                                            :href="whatsappLink"
                                            rel="nofollow"
                                            @mouseenter="onMouseenter(index)"
                                            @mouseleave="onMouseleave(index)"
                                        >
                                            {{ whatsappNumber }}
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="customer-item customer-item-social d-none d-md-block">
                        <div class="title">
                            {{ $t('footer.follow') }}
                        </div>
                        <div class="social-icon">
                            <a
                                v-for="(url, key) in socialMap"
                                :key="key"
                                :href="url"
                                :class="['icon', classMap[key]]"
                                rel="nofollow"
                                target="_blank"
                            />
                        </div>
                    </div>
                </div>
                <div class="customer-right">
                    <div class="map-wrapper">
                        <ec-image :webp="require('./img/icons/map.webp')">
                            <a
                                :href="googleMap"
                                target="_blank"
                                rel="nofollow"
                            >
                                <img
                                    class="d-none d-md-block"
                                    src="./img/icons/map.png"
                                    alt="gmaplogo"
                                    loading="lazy"
                                >
                            </a>
                        </ec-image>
                        <ec-image :webp="require('./img/icons/map-sm.webp')">
                            <a
                                :href="googleMap"
                                target="_blank"
                                rel="nofollow"
                            >
                                <img
                                    class="d-block d-md-none"
                                    src="./img/icons/map-sm.png"
                                    alt="gmaplogo"
                                    loading="lazy"
                                >
                            </a>
                        </ec-image>
                        <div class="map-address">
                            <div
                                v-for="(item, index) in $t('footer.address.content')"
                                :key="index"
                            >
                                {{ item }}
                            </div>
                        </div>
                    </div>
                    <div class="customer-item customer-item-social d-block d-md-none">
                        <div class="title">
                            {{ $t('footer.follow') }}
                        </div>
                        <div class="social-icon">
                            <a
                                v-for="(url, key) in socialMap"
                                :key="key"
                                :href="url"
                                :class="['icon', classMap[key]]"
                                rel="nofollow"
                                target="_blank"
                            />
                        </div>
                    </div>
                    <div
                        class="btn-wrapper"
                        :style="{
                            justifyContent: $app.isIOS || $app.isAndroid ? 'center' : 'unset'
                        }"
                    >
                        <app-store-button
                            v-if="!$app.isIOS"
                            class="btn"
                            type="google"
                        />
                        <app-store-button
                            v-if="!$app.isAndroid"
                            class="btn"
                            type="apple-w"
                        />
                    </div>
                </div>
            </div>
        </div>

        <div class="ec-container">
            <div class="seperator" />
        </div>

        <div class="contact-info">
            <div class="ec-container attention-text">
                <div class="attention">
                    {{ $t('footer.perhatian') }}
                </div>

                <div class="attention-content">
                    <div class="attention-content-item">
                        <div
                            v-for="(item, index) in $t('footer.perhatianTextMap')"
                            :key="index"
                        >
                            <div
                                v-if="index < 4"
                                class="notice-info"
                            >
                                <span>{{ item }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="attention-content-item">
                        <ul
                            v-for="(item, index) in $t('footer.perhatianTextMap')"
                            :key="index"
                        >
                            <li
                                v-if="index >= 4"
                                class="notice-info"
                            >
                                <span>{{ item }}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <div class="ec-container">
            <div class="seperator" />
        </div>

        <div class="contact-info">
            <div class="ec-container">
                <div class="copy-right">
                    <span>{{ $t('footer.copyRight', [new Date().getFullYear()]) }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/babel">
import {mapState} from 'vuex';

import businessData from 'easycash/common/mixin/business-data';

import AppStoreButton from './app-store-button';
import clock from './img/icons/clock.svg';
import email from './img/icons/email.svg';
import telephone from './img/icons/telephone.svg';

const socialMap = {
    facebook: 'https://www.facebook.com/EasycashIndonesia',
    instagram: 'https://www.instagram.com/easycash.ind',
    tiktok: 'https://www.tiktok.com/@easycash.id',
    twitter: 'https://twitter.com/easycashid',
    linkedin: 'https://www.linkedin.com/company/fintopia-indonesia/'
};

const classMap = {
    facebook: 'icon-fa',
    instagram: 'icon-in',
    tiktok: 'icon-ti',
    twitter: 'icon-tw',
    linkedin: 'icon-li'
};

export default {
    name: 'EcFooter',

    i18n: {
        messages: {
            en: {
                footer: {
                    contact: 'Contact Us',
                    borrower: 'Borrower',
                    lender: 'Lender',
                    customer: {
                        borrower: '1500866',
                        lender: '1500866'
                    },
                    workingHours: {
                        borrower: 'Monday - Sunday 08:00 - 20:00',
                        lender: 'Monday - Sunday 09:00 - 18:00'
                    },
                    follow: 'Follow us',
                    address: {
                        title: 'Office: ',
                        content: [
                            'DEA TOWER 2 18-20 FLOOR MEGA KUNINGAN AREA',
                            'JL. MEGA KUNINGAN BARAT KAV. E4 NO. 1-2, Desa/Kelurahan Kuningan Timur,',
                            'Kec. Setiabudi, Kota Adm. Jakarta Selatan, Provinsi DKl Jakarta, Kode Pos: 12950'
                        ]
                    },
                    downloadApp: 'Download App',
                    perhatian: 'ATTENTION',
                    perhatianTextMap: [
                        'PT Indonesia Fintopia Technology provides peer-to-peer (P2P) lending platform service under the name “Easycash”. Easycash is licensed and supervised by The Financial Services Authority as an Information Technology-Based Co-Funding Service in accordance with the provisions in The Financial Services Authority Regulation No. 10/POJK.05/2022.',
                        'Easycash’s Information Technology-Based Co-Funding Service (“Easycash Service”) is a civil agreement between the Lender and the Borrower, so that all forms of risk and legal consequences arising from it are fully borne by each party. Please ensure you understand the risks associated before you use Easycash Service.',
                        'The Lender is fully responsible for all funding risks of late or default payments arising out of the use of Easycash Service. No national entity or authority is responsible for any such risks or provides compensation for the losses or other consequences arising in connection with this matter in any form.',
                        'Easycash, with the approval of the respective Users (both Lender and Borrower), may access, acquire, store, administer and/or use the Users\' personal data and information ("Data Utilization") on the Users\' electronic devices (including smartphones or cellular phones), hardware, software, electronic documents, applications or electronic systems owned by the Users or controlled by the Users, by notifying the purpose, limitations and mechanisms of the data utilization to the Users concerned before obtaining such approval.',
                        'Lenders who do not have sufficient knowledge and experience in the Information Technology-Based Co-Funding Service are not advised to use this Easycash Service.',
                        'Borrowers should carefully consider the loan interest rate along with other costs in accordance with the ability to pay off the loan prior to using Easycash.',
                        'All fraudulent activities will be recorded digitally in cyberspace and may potentially be informed to the public through social media and can be used as legal evidence according to the prevailing laws on electronic information and transactions in the event of dispute resolution and law enforcement.',
                        "Users should read and understand this information before becoming a Lender or a Borrower on Easycash. The Users' decision to use Easycash Services proves that the Users fully understand this information.",
                        "The Financial Services Authority is not responsible for any violation or non-compliance by the User (either the Lender or the Borrower), whether due to the User's faults or negligence of the laws and regulations or agreements between Easycash and the Lender and/or the Borrower."
                    ],
                    copyRight: 'Copyright © {0} PT Indonesia Fintopia Technology. All rights reserved.',
                    specialTime:
                        'Due to the presidential election, customer service on February 14th will be available from 11:00 to 20:00.'
                }
            },
            id: {
                footer: {
                    contact: 'Hubungi Kami',
                    borrower: 'Pinjaman',
                    lender: 'Pendanaan',
                    customer: {
                        borrower: '1500866',
                        lender: '1500866'
                    },
                    workingHours: {
                        borrower: 'Senin - Minggu 08.00 - 20.00',
                        lender: 'Senin - Minggu 09.00 - 18.00'
                    },
                    follow: 'Ikuti kami',
                    address: {
                        title: 'Alamat Kantor: ',
                        content: [
                            'DEA TOWER 2 LANTAI 18-20 KAWASAN MEGA KUNINGAN',
                            'JL. MEGA KUNINGAN BARAT KAV. E4 NO. 1-2, Desa/Kelurahan Kuningan Timur,',
                            'Kec. Setiabudi, Kota Adm. Jakarta Selatan, Provinsi DKl Jakarta, Kode Pos: 12950'
                        ]
                    },
                    downloadApp: 'Unduh Aplikasi',
                    perhatian: 'PERHATIAN',
                    perhatianTextMap: [
                        'PT Indonesia Fintopia Technology menyediakan layanan platform Peer-to-Peer (P2P) Lending dengan nama “Easycash”. Easycash berizin dan diawasi oleh Otoritas Jasa Keuangan sebagai penyelenggara Layanan Pendanaan Bersama Berbasis Teknologi Informasi sesuai dengan ketentuan dalam Peraturan Otoritas Jasa Keuangan No. 10/POJK.05/2022.',
                        'Layanan Pendanaan Bersama Berbasis Teknologi Informasi Easycash (“Layanan Easycash”) merupakan kesepakatan perdata antara Pemberi Dana dan Penerima Dana, sehingga segala bentuk risiko dan akibat hukum yang timbul karenanya sepenuhnya ditanggung oleh masing-masing pihak. Pastikan Anda memahami risiko yang ada sebelum Anda menggunakan Layanan Easycash.',
                        'Risiko pendanaan atau gagal bayar yang timbul dari penggunaan Layanan Easycash sepenuhnya menjadi tanggung jawab dari Pemberi Dana. Tidak ada lembaga atau otoritas negara yang bertanggung jawab atas risiko tersebut atau memberikan kompensasi atas kerugian atau konsekuensi lainnya yang timbul sehubungan dengan hal tersebut dalam bentuk apapun.',
                        'Easycash, dengan persetujuan dari setiap Pengguna (baik Pemberi Dana maupun Penerima Dana), dapat mengakses, memperoleh, menyimpan, mengelola dan/atau menggunakan data dan informasi pribadi Pengguna (“Pemanfaatan Data”) pada perangkat elektronik (termasuk smartphone atau telepon seluler), perangkat keras (hardware) maupun lunak (software), dokumen elektronik, aplikasi, atau sistem elektronik milik Pengguna atau yang dikuasai oleh Pengguna, dengan memberitahukan tujuan, batasan, dan mekanisme Pemanfaatan Data tersebut kepada Pengguna yang bersangkutan sebelum memperoleh persetujuan yang dimaksud.',
                        'Pemberi Dana yang belum memiliki pengetahuan dan pengalaman dalam hal Layanan Pendanaan Bersama Berbasis Teknologi Informasi disarankan untuk tidak menggunakan Layanan Easycash.',
                        'Penerima Dana wajib mempertimbangkan tingkat suku bunga pinjaman serta biaya lainnya sesuai dengan kemampuannya dalam melunasi pinjaman sebelum menggunakan Layanan Easycash.',
                        'Setiap kecurangan tercatat secara digital di dunia maya dan dapat diketahui oleh masyarakat luas melalui media sosial serta dapat menjadi alat bukti hukum yang sah menurut peraturan perundang-undangan yang berlaku tentang informasi dan transaksi elektronik dalam proses penyelesaian sengketa dan penegakan hukum.',
                        'Pengguna wajib membaca dan memahami informasi ini sebelum mengambil keputusan untuk menjadi Pemberi Dana ataupun Penerima Dana pada Easycash. Keputusan Pengguna untuk menggunakan Layanan Easycash menjadi bukti dan pengakuan bahwa Pengguna telah memahami informasi ini sepenuhnya.',
                        'Otoritas Jasa Keuangan tidak bertanggung jawab atas setiap pelanggaran atau ketidakpatuhan oleh Pengguna (baik Pemberi Dana maupun Penerima Dana), baik karena kesengajaan atau kelalaian Pengguna terhadap ketentuan peraturan perundang-undangan maupun kesepakatan atau perikatan antara Easycash dengan Pemberi Dana dan/atau Penerima Dana.'
                    ],
                    copyRight: 'Hak Cipta © {0} PT Indonesia Fintopia Technology. Semua Hak Dilindungi Undang-Undang.',
                    specialTime: 'Dikarenakan adanya Pemilihan Umum, 14/2/2024 Jam Operasional CS: 11.00-20.00'
                }
            }
        }
    },

    components: {
        AppStoreButton
    },

    mixins: [businessData],

    data() {
        return {
            isHoverBorrow: false,
            isHoverLend: false,
            socialMap,
            classMap,
            googleMap: 'https://goo.gl/maps/riaveCzX3VjM91XY7'
        };
    },

    computed: {
        ...mapState('contact', ['yqdContact', 'finContact']),

        whatsappNumber() {
            const {whatsappLink} = this;

            const phone = whatsappLink?.split('phone=')?.[1]?.replace(/^62/, '0');

            return phone.slice(0, 4) + '-' + phone.slice(4);
        },

        whatsappLink() {
            return this.getBusinessData('whatsappCustomerServiceLink');
        },

        showWhatsapp() {
            return this.getBusinessData('showWhatsapp');
        },

        whatsappQr() {
            return this.getBusinessData('whatsappCustomerServiceQr');
        },

        customerServiceTimeTip() {
            const customerServiceTimeTip = this.getBusinessData('customerServiceHoursWebsite');
            const {locale, fallbackLocale} = this.$i18n;
            const localeFinal = locale === 'en' ? locale : fallbackLocale;

            return customerServiceTimeTip?.[localeFinal];
        },

        customerList() {
            return [
                {
                    title: this.$t('footer.borrower'),
                    color: '#03DA8B',
                    contact: [
                        {icon: telephone, value: this.$t('footer.customer.borrower')},
                        {icon: email, value: this.yqdContact.email, minWidth: '1.7rem'},
                        {icon: clock, value: this.$t('footer.workingHours.borrower')}
                    ]
                },
                {
                    title: this.$t('footer.lender'),
                    color: '#000AFF',
                    contact: [
                        {icon: telephone, value: this.$t('footer.customer.lender')},
                        {icon: email, value: this.finContact.email, minWidth: '1.7rem'},
                        {icon: clock, value: this.$t('footer.workingHours.lender')}
                    ]
                }
            ];
        }
    },

    methods: {
        onMouseenter(idx) {
            this[idx === 0 ? 'isHoverBorrow' : 'isHoverLend'] = true;
        },

        onMouseleave(idx) {
            this[idx === 0 ? 'isHoverBorrow' : 'isHoverLend'] = false;
        }
    }
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
@import "~easycash/common/style/style";

.ec-footer {
    background-color: #000;
    color: #fff;
    z-index: 5;

    .seperator {
        height: 1px;
        width: 100%;
        background-color: #dcdbdb;
    }

    .padding-top {
        padding-top: 0.6rem;

        @media screen and (max-width: $screen-md) {
            padding-top: 0.4rem;
        }
    }

    .contact-info {
        justify-content: center;

        .top-wrapper {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            flex-wrap: wrap;
            align-items: flex-start;

            @media screen and (max-width: $screen-md) {
                flex-direction: column;
                align-items: flex-start;
            }

            .customer-left {
                display: flex;
                flex-direction: column;

                @media screen and (max-width: $screen-md) {
                    padding-bottom: 0;
                }

                .customer-item {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    margin-bottom: 0.4rem;

                    @media screen and (max-width: $screen-md) {
                        margin-bottom: 0.2rem;

                        &:first-child,
                        &:last-child {
                            margin-bottom: 0.3rem;
                        }
                    }

                    .contact-ec {
                        font-weight: 700;
                        font-size: 0.18rem;
                    }

                    &-contact {
                        flex-direction: column;
                        align-items: flex-start;

                        .contact {
                            display: flex;
                            align-items: center;
                            margin-top: 0.1rem;
                            flex-wrap: wrap;

                            .contact-item {
                                position: relative;
                                display: flex;
                                align-items: center;
                                font-size: 0.12rem;

                                a {
                                    color: #fff;
                                    cursor: pointer;
                                }

                                &:not(:last-child),
                                .whatsapp {
                                    margin-right: 0.4rem;

                                    &:hover,
                                    &:active {
                                        opacity: 0.6;
                                    }
                                }

                                .whatsapp {
                                    display: flex;
                                }

                                .qr-wrap {
                                    border-radius: 0.16rem;
                                    width: 2rem;
                                    height: 2rem;
                                    position: absolute;
                                    left: 0;
                                    bottom: calc(100% + 0.15rem);
                                    box-sizing: border-box;
                                    padding: 0.15rem;
                                    background-color: #fff;
                                }
                            }
                        }

                        .whatsapp {
                            margin-top: 0.04rem;

                            @media screen and (max-width: $screen-md) {
                                margin-top: 0;
                            }
                        }

                        @media screen and (max-width: $screen-md) {
                            border-left: none !important;
                            padding-left: 0;

                            .contact {
                                flex-wrap: wrap;

                                .contact-item {
                                    margin-bottom: 0.1rem;

                                    a {
                                        color: #fff;
                                    }
                                }
                            }
                        }
                    }

                    &-top {
                        padding-left: 0.1rem;

                        @media screen and (max-width: $screen-md) {
                            border-left: none !important;
                            padding-left: 0;
                        }
                    }

                    &-social {
                        flex-direction: column;
                        align-items: flex-start;
                    }

                    .title {
                        font-size: 0.18rem;
                        font-weight: 300;
                        line-height: 0.18rem;
                    }

                    &-logo {
                        height: 0.4rem;
                        width: 0.4rem;
                        margin-right: 0.1rem;
                    }

                    &-icon {
                        height: 0.16rem;
                        width: 0.16rem;
                        margin-right: 0.05rem;
                    }

                    .special-time {
                        position: relative;
                        text-align: right;
                        max-width: 5.2rem;
                        margin-left: auto;
                        padding: 0.055rem 0.15rem 0.035rem;
                        background: rgba(63, 202, 88, 0.3);
                        border-radius: 0.05rem;
                        font-size: 0.12rem;
                        font-weight: 400;
                        line-height: 0.14rem;
                        letter-spacing: 0;
                        margin-top: 0.15rem;
                        margin-bottom: 0.1rem;

                        &::after {
                            position: absolute;
                            right: 0.3rem;
                            top: -0.1rem;
                            content: "";
                            width: 0;
                            height: 0;
                            border-left: 0.05rem solid transparent;
                            border-right: 0.05rem solid transparent;
                            border-bottom: 0.1rem solid rgba(63, 202, 88, 0.3);
                        }

                        @media screen and (max-width: $screen-md) {
                            padding: 0.09rem 0.1rem 0.07rem;
                            margin-top: 0;
                            margin-left: unset;
                            margin-right: auto;

                            &::after {
                                left: 0.3rem;
                                top: -0.08rem;
                                border-left: 0.04rem solid transparent;
                                border-right: 0.04rem solid transparent;
                                border-bottom: 0.08rem solid rgba(63, 202, 88, 0.3);
                            }
                        }
                    }
                }
            }

            .customer-right {
                margin-top: 0.8rem;

                @media screen and (max-width: $screen-md) {
                    margin-top: 0;
                }

                .map-wrapper {
                    display: flex;
                    align-items: flex-start;
                    margin-bottom: 0.37rem;

                    img {
                        width: 2.4rem;
                        height: 1.4rem;
                        margin-right: 0.2rem;
                        cursor: pointer;
                        border-radius: 0.08rem;
                    }

                    .map-address {
                        width: 2.4rem;
                        font-size: 0.12rem;
                        line-height: 0.1875rem;
                    }

                    @media screen and (max-width: $screen-md) {
                        margin-bottom: 0.3rem;

                        img {
                            width: 1rem;
                            height: 1.5rem;
                            margin-right: 0.1rem;
                        }

                        .map-address {
                            width: auto;
                        }
                    }
                }

                .btn-wrapper {
                    display: flex;
                    flex-direction: row;
                    margin-bottom: 0.5rem;

                    .btn {
                        ::v-deep {
                            .channel-btn {
                                width: 2.4rem;
                                height: 0.48rem;
                                margin-right: 0.2rem;
                            }
                        }
                    }

                    @media screen and (max-width: $screen-md) {
                        margin: 0.3rem 0;

                        .btn {
                            ::v-deep {
                                .channel-btn {
                                    width: 1.65rem;
                                    height: 0.48rem;
                                    margin-right: 0.05rem;
                                }
                            }
                        }
                    }
                }
            }
        }

        .attention-text {
            margin-top: 0.6rem;
            margin-bottom: 0.5rem;

            @media screen and (max-width: $screen-md) {
                margin-top: 0.3rem;
                margin-bottom: 0.1rem;
            }

            .attention {
                font-size: 0.18rem;
                margin-bottom: 0.4rem;
                text-align: left;
                font-weight: 700;

                @media screen and (max-width: $screen-md) {
                    margin-bottom: 0.1rem;
                }
            }

            .attention-content {
                display: flex;

                &-item {
                    width: 50%;

                    &:first-child {
                        padding-right: 0.1rem;
                    }

                    &:last-child {
                        padding-left: 0.1rem;
                    }

                    .notice-info {
                        display: flex;
                        text-align: justify;
                        font-size: 0.12rem;
                        font-weight: 300;
                        line-height: 0.18rem;
                        margin-bottom: 0.2rem;

                        &::before {
                            content: "";
                            display: block;
                            width: 2px;
                            height: 2px;
                            border-radius: 50%;
                            background-color: #fff;
                            flex-shrink: 0;
                            margin-right: 0.08rem;
                            margin-top: 0.08rem;
                        }
                    }
                }

                @media screen and (max-width: $screen-md) {
                    flex-wrap: wrap;

                    &-item {
                        width: 100%;

                        &:first-child {
                            padding-right: 0;
                        }

                        &:last-child {
                            padding-left: 0;
                        }
                    }
                }
            }
        }

        .copy-right {
            padding: 0.3rem 0;
            text-align: center;
            font-size: 0.12rem;
            font-weight: 300;
        }
    }

    .customer-item-social {
        flex-direction: column;
        align-items: flex-start;

        .title {
            font-size: 0.18rem;
            font-weight: 300;
            line-height: 0.18rem;
        }

        .social-icon {
            display: flex;
            flex-direction: row;
            margin: 0.2rem 0 0.1rem;

            .icon {
                width: 0.4rem;
                height: 0.4rem;
                margin-right: 0.2rem;
                background-repeat: no-repeat;
                background-size: contain;
                cursor: pointer;

                @media screen and (max-width: $screen-md) {
                    margin-right: 0.1rem;
                }
            }

            .icon-fa {
                background-image: url("./img/icons/facebook.svg");

                &:hover,
                &:active {
                    background-image: url("./img/icons/facebook-a.svg");
                }
            }

            .icon-in {
                background-image: url("./img/icons/instagram.svg");

                &:hover,
                &:active {
                    background-image: url("./img/icons/instagram-a.svg");
                }
            }

            .icon-tw {
                background-image: url("./img/icons/twitter.svg");

                &:hover,
                &:active {
                    background-image: url("./img/icons/twitter-a.svg");
                }
            }

            .icon-ti {
                background-image: url("./img/icons/tiktok.svg");

                &:hover,
                &:active {
                    background-image: url("./img/icons/tiktok-a.svg");
                }
            }

            .icon-li {
                background-image: url("./img/icons/linkedin.svg");

                &:hover,
                &:active {
                    background-image: url("./img/icons/linkedin-a.svg");
                }
            }
        }
    }
}
</style>
